import React from "react";
import { MantineProvider, MantineThemeColorsOverride } from "@mantine/core";
import makeTheme from "./theme";

interface Props {
    children: JSX.Element;
}

export default function ThemeProvider({ children }: Props) {
    const brand = "cs";

    const theme = makeTheme(brand) as MantineThemeColorsOverride;

    return (
        <MantineProvider withGlobalStyles withNormalizeCSS theme={theme}>
            {children}
        </MantineProvider>
    );
}
